var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableHeadRow, TableRow, } from "../../table/simple";
import { DishOptionSetList } from "./dish-option-set-list";
import { DishIngredientsList } from "./dish-ingredients-list";
import { DishComboChoiceList } from "./dish-combo-list";
import { formatCurrency, orderDish } from "@lib/common";
import { styled } from "../../../index";
const OrderItemsSeatHeader = styled.div `
  background-color: #ecedf0;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-top: 1px solid #d1d2da;
  border-bottom: 1px solid #d1d2da;
  line-height: 1;
  margin-top: 4px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
let OrderItems = class OrderItems extends React.Component {
    render() {
        var _a, _b, _c, _d, _e;
        const { items, itemContent, headerItemContent, disableHeader, disableBorder, disableLastBorder, seatHeaderClassName, seatHeaderStyle, onRowClick, noStockDishes, noStockOptions, } = this.props;
        const detailEnabled = (_a = this.props.detailEnabled) !== null && _a !== void 0 ? _a : true;
        const detailPrices = (_b = this.props.detailPrices) !== null && _b !== void 0 ? _b : true;
        const detailOptionPrices = (_c = this.props.detailOptionPrices) !== null && _c !== void 0 ? _c : true;
        const detailComboChoiceNames = (_d = this.props.detailComboChoiceNames) !== null && _d !== void 0 ? _d : true;
        const detailDisablePrintName = (_e = this.props.detailDisablePrintName) !== null && _e !== void 0 ? _e : true;
        if (!detailEnabled) {
            return null;
        }
        const allSeats = (() => {
            const seats = [];
            for (const item of items) {
                if (item.table_seat_num && seats.indexOf(item.table_seat_num) === -1) {
                    seats.push(item.table_seat_num);
                }
            }
            return seats.sort();
        })();
        const allTags = (() => {
            const tags = [];
            for (const item of items) {
                if (item.tag_name && item.tag_sort) {
                    const existing = tags.find((t) => t.name === item.tag_name && t.sort === item.tag_sort);
                    if (!existing) {
                        tags.push({
                            name: item.tag_name,
                            sort: item.tag_sort,
                        });
                    }
                }
            }
            return tags.sort((a, b) => a.sort - b.sort);
        })();
        const allSeatTags = (() => {
            const variations = [
                {
                    seat: null,
                    tag: null,
                },
            ];
            if (allSeats.length > 0 && allTags.length === 0) {
                for (const seat of allSeats) {
                    variations.push({
                        seat: seat,
                        tag: null,
                    });
                }
            }
            else if (allSeats.length === 0 && allTags.length > 0) {
                for (const tag of allTags) {
                    variations.push({
                        seat: null,
                        tag: tag,
                    });
                }
            }
            else if (allSeats.length > 0 && allTags.length > 0) {
                for (const tag of allTags) {
                    variations.push({
                        seat: null,
                        tag: tag,
                    });
                }
                for (const seat of allSeats) {
                    variations.push({
                        seat: seat,
                        tag: null,
                    });
                    for (const tag of allTags) {
                        variations.push({
                            seat: seat,
                            tag: tag,
                        });
                    }
                }
            }
            return variations;
        })();
        const itemsBySeatTags = allSeatTags.map(({ seat, tag }) => {
            return {
                seat: seat,
                tag: tag,
                items: items.filter((item) => {
                    return ((item.table_seat_num || null) === seat &&
                        (item.tag_name || null) === ((tag === null || tag === void 0 ? void 0 : tag.name) || null) &&
                        (item.tag_sort || null) === ((tag === null || tag === void 0 ? void 0 : tag.sort) || null));
                }),
            };
        });
        return itemsBySeatTags.map(({ items, seat, tag }, i) => {
            var _a;
            if (items.length === 0 && (seat || tag))
                return null;
            const isItemsOnNextSection = !!((_a = itemsBySeatTags[i + 1]) === null || _a === void 0 ? void 0 : _a.items);
            return (React.createElement(React.Fragment, { key: i },
                (seat !== null || tag !== null) && (React.createElement(OrderItemsSeatHeader, { className: seatHeaderClassName, style: seatHeaderStyle },
                    seat !== null ? React.createElement("p", null,
                        "Seat: ",
                        seat) : React.createElement("p", null),
                    tag !== null ? React.createElement("p", null, tag.name) : React.createElement("p", null))),
                React.createElement(Table, { style: {
                        marginBottom: items.length === 0 && seat === null && tag === null ? "-5px" : 0,
                    } },
                    seat === null && tag === null && !disableHeader && (React.createElement(TableHead, null,
                        React.createElement(TableHeadRow, null,
                            React.createElement(TableHeadCell, { className: "cart-items-head-qty", style: { width: "40px" } }, "Qty"),
                            React.createElement(TableHeadCell, { className: "text-left" }, !headerItemContent ? "Item" : headerItemContent()),
                            detailPrices && (React.createElement(TableHeadCell, { className: "cart-items-head-price", style: { width: "80px" } }, "Price"))))),
                    React.createElement(TableBody, { style: { verticalAlign: "top" } }, items.map((dish, i) => {
                        const { price, basePrice, priceDiffSingle } = orderDish.total(dish);
                        const rowClick = !onRowClick ? undefined : () => onRowClick(dish, i);
                        let name = detailDisablePrintName ? dish.name : dish.print_name || dish.name;
                        name = name.replace(/<br>/g, " ");
                        return (React.createElement(TableRow, { key: i, disableBorder: disableBorder, disableLastBorder: disableLastBorder || isItemsOnNextSection, className: rowClick ? "text-md cursor-pointer" : "text-md", onClick: rowClick },
                            React.createElement(TableCell, { style: { width: "40px" } }, dish.quantity),
                            React.createElement(TableCell, { className: "text-left" },
                                React.createElement("div", { className: "break-words" },
                                    noStockDishes && noStockDishes.indexOf(dish.id) !== -1 && (React.createElement("div", { className: "rounded px-2 py-1 text-white uppercase inline-block font-semibold", style: {
                                            fontSize: "10px",
                                            marginBottom: "5px",
                                            background: "#bd362f",
                                            lineHeight: 1,
                                        } }, "No Stock")),
                                    React.createElement("div", null, name),
                                    dish.subtitle && React.createElement("div", { className: "text-sm" }, dish.subtitle)),
                                dish.type !== "combo" && (React.createElement("div", null,
                                    (dish.options || []).length > 0 && (React.createElement("div", null,
                                        React.createElement(DishOptionSetList, { options: dish.options, detailOptionPrices: detailOptionPrices, noStockOptions: noStockOptions }))),
                                    (dish.ingredients || []).length > 0 && (React.createElement("div", null,
                                        React.createElement(DishIngredientsList, { ingredients: dish.ingredients }))))),
                                dish.type === "combo" && (React.createElement("div", null,
                                    React.createElement(DishComboChoiceList, { choices: dish.choices, detailOptionPrices: detailOptionPrices, detailComboChoiceNames: detailComboChoiceNames, noStockDishes: noStockDishes, noStockOptions: noStockOptions }))),
                                dish.notes && React.createElement("div", { className: "mt-2 text-sm" },
                                    "Notes: ",
                                    dish.notes),
                                itemContent && itemContent(dish, i)),
                            detailPrices && (React.createElement(TableCell, { style: { width: "80px" } },
                                priceDiffSingle === 0 && React.createElement("div", null, formatCurrency(price)),
                                priceDiffSingle !== 0 && (React.createElement("div", { className: "text-sm" },
                                    React.createElement("s", null, formatCurrency(basePrice)))),
                                priceDiffSingle !== 0 && React.createElement("div", null, formatCurrency(price))))));
                    })))));
        });
    }
};
OrderItems = __decorate([
    observer
], OrderItems);
export { OrderItems };
//# sourceMappingURL=index.js.map